import { router } from "@inertiajs/react"
import { useEffect, useRef } from "react"

/*
 * The in-call panel's clock: an Inertia partial reload on a short interval
 * while the session is live. The server side is one row read plus one
 * `Trumpet::Voice.find`, no provider call, so two seconds is cheap. Stops on
 * its own once the session rests or ends; pauses while the tab is hidden;
 * never overlaps itself.
 */
export function useSessionPoll({
  enabled,
  path,
  only,
  intervalMs = 2000,
}: {
  enabled: boolean
  /** The canonical GET for the page, not the current URL: after a POST the URL may not be reloadable. */
  path: string
  only: string[]
  intervalMs?: number
}) {
  const inFlight = useRef(false)
  useEffect(() => {
    if (!enabled) return undefined
    const tick = () => {
      if (document.hidden || inFlight.current) return
      inFlight.current = true
      router.visit(path, {
        only,
        preserveScroll: true,
        preserveState: true,
        onFinish: () => {
          inFlight.current = false
        },
      })
    }
    const id = window.setInterval(tick, intervalMs)
    return () => window.clearInterval(id)
  }, [enabled, path, intervalMs, only.join(",")]) // eslint-disable-line react-hooks/exhaustive-deps
}
